import $ from "jquery";

function selectedIds() {
  return Array.from(document.querySelectorAll(".group_check_box"))
    .filter((input) => input.checked)
    .map((input) => input.value);
}

$(() => {
  // Forms
  document.querySelectorAll(".group-functions form").forEach((form) => {
    form.addEventListener("submit", () => {
      form.querySelectorAll(".ids").forEach((input) => {
        input.value = selectedIds().join(",");
      });
    });
  });
});
